import React, {Component} from 'react';
import {connect} from 'react-redux';
import {calcPercentage} from 'helpers/common-helper';
import ComboExposureMax from './combo-exposure-max';
import FilterLineupsByKeyPlayerStackCombinations from 'components/molecules/filter-lineups-by-key-player-stack-combinations';

class CombinationsBox extends Component {
    getCombinationsNotFoundView() {
        return (
            <table className="table">
                <tbody>
                    <tr key="teams-not-found" className="empty">
                        <td>Combinations were not found.</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    getStackedPlayersNotFoundView() {
        return (
            <tr key={-1}>
                <td>
                    <strong>No stacked players found</strong>
                </td>
                <td></td>
                <td></td>
            </tr>
        );
    }

    getView(params) {
        const {content} = params;
        return (
            <div className="players-used-table">
                <div className="table-scroll-static">{content}</div>
            </div>
        );
    }

    getUsedCombinationsView(params) {
        const {rawLineups, players} = this.props;
        const {group, index} = params;
        const player = players.getPlayer(group.playerId);

        const combinationViews = [];
        if (isEmpty(group.sortedCombos)) {
            combinationViews.push(this.getStackedPlayersNotFoundView());
        } else {
            group.sortedCombos.map((combo, index) => {
                combinationViews.push(this.getCombinationView({group, index, combo, keyPlayer: player}));
            });
        }

        const percentage = calcPercentage(rawLineups.getQuantity(), group.quantity);

        return (
            <table key={`key-player-${index}`} className="table">
                <thead>
                    <tr className="hidden-heading">
                        <th className="td-icon"></th>
                        <th>{`${player.positionName} ${player.name}`}</th>
                        <th className="td-stack-per">{`${percentage}% (${group.quantity})`}</th>
                        <th className="td-stack-exp">
                            Exp.
                            <br />
                            max
                        </th>
                    </tr>
                </thead>
                <tbody>{combinationViews}</tbody>
            </table>
        );
    }

    getUnusedCombinationsView(params) {
        const {players} = this.props;
        const {group, index} = params;

        if (isEmpty(group.sortedCombos)) {
            return null;
        }

        const player = players.getPlayer(group.playerId);

        const combinationViews = [];
        group.sortedCombos.map((combo, index) => {
            combinationViews.push(this.getCombinationView({group, index, combo, keyPlayer: player}));
        });

        return (
            <table key={`unused-${index}`} className="table">
                <thead>
                    <tr className="hidden-heading">
                        <th className="td-icon"></th>
                        <th>{`${player.positionName} ${player.name}`}</th>
                        <th className="td-stack-per">{'0%'}</th>
                        <th className="td-stack-exp">
                            Exp.
                            <br />
                            max
                        </th>
                    </tr>
                </thead>
                <tbody>{combinationViews}</tbody>
            </table>
        );
    }

    getCombinationView(params) {
        const {players} = this.props;
        const {group, index, combo, keyPlayer} = params;

        const playerDepictions = [];
        combo.getPlayerIds().map((playerId) => {
            const player = players.getPlayer(playerId);

            if (keyPlayer.team === player.team) {
                playerDepictions.push(`${player.positionName} ${player.name}`);
            } else {
                playerDepictions.push(`OPP ${player.positionName} ${player.name}`);
            }
        });

        const className = index % 2 === 0 ? 'even' : '';
        const percentage = calcPercentage(group.quantity, combo.getQuantity());

        return (
            <tr key={`combo-${index}`} className={className}>
                <td>
                    <FilterLineupsByKeyPlayerStackCombinations combo={combo} />
                </td>
                <td>
                    <strong>{playerDepictions.join(' + ')}</strong>
                </td>
                <td className="td-stack-per text-blue">{`${percentage}% (${combo.getQuantity()})`}</td>
                <td className="td-stack-exp">
                    <ComboExposureMax
                        className={'form-control small-table-input'}
                        defaultValue={combo.getQuantity()}
                        stackItemId={group.playerId}
                        combo={combo.getPlayerIds()}
                    />
                </td>
            </tr>
        );
    }

    render() {
        const {comboGroups} = this.props;

        const groupsUsedInLineups = comboGroups.getGroupsUsedInLineups();
        const groupsUnusedInLineups = comboGroups.getGroupsUnusedInLineups();

        if (isEmpty(groupsUsedInLineups) && isEmpty(groupsUnusedInLineups)) {
            return this.getView({
                content: this.getCombinationsNotFoundView(),
            });
        }

        const usedCombinations = groupsUsedInLineups.map((group, index) => {
            return this.getUsedCombinationsView({index, group});
        });

        const unusedCombinations = groupsUnusedInLineups.map((group, index) => {
            return this.getUnusedCombinationsView({index, group});
        });

        return this.getView({
            content: [...usedCombinations, <div key="-1" className="unused-combinations"></div>, ...unusedCombinations],
        });
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {rawLineups},
        playersData: {players},
        keyPlayerStacking: {combinations},
    } = state;

    return {
        players,
        rawLineups,
        comboGroups: combinations.groups,
    };
}

export default connect(mapStatesToProps)(CombinationsBox);
